import cc from "classcat"
import { ReactNode } from "react"
import { Link } from "react-router-dom"
import { ReactComponent as Check } from "../svg/check.svg"

interface ProgressProps {
  vertical?: boolean
  children?: ReactNode
}

interface ProgressItemProps {
  id: string
  to: string
  label: ReactNode
  children?: ReactNode
  complete?: boolean
  active?: boolean
}

export function Progress({ vertical, children }: ProgressProps) {
  return (
    <nav className={vertical ? "progress-vertical" : "progress"}>
      <ol className="w-full">{children}</ol>
    </nav>
  )
}

export function ProgressItem({
  to,
  id,
  label,
  complete,
  active,
  children,
}: ProgressItemProps) {
  const className = cc({
    progress__item: true,
    "progress__item--complete": complete,
    "progress__item--active": active,
  })

  return (
    <li className={className} aria-current={active && "step"}>
      <Link
        id={id}
        to={to}
        className="progress__label"
        aria-current={active && "step"}
      >
        <span className="progress__icon">
          {complete && <Check fill="currentColor" stroke="currentColor" />}
        </span>
        {label}
      </Link>

      {children && (
        <div className="progress__content" aria-labelledby={id}>
          {children}
        </div>
      )}
    </li>
  )
}
